import React, { useEffect, useState } from 'react';
import { axisMaxLogo } from '../../images/images';
import './AppNavbar.css';
import { arrowLeftImg, backImg } from '../../images/TeleBindingImages/TeleBindingImages';
import { ArrowIcon } from 'unified-ui-components-library/dist/systemIcons';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { getCurrentStepLabelForTB } from '../../utils/handleProgress';
import { CAPS_Y } from '../../utils/constants';

const AppNavbar = ({ isLoggedIn, handleLogout }) => {
    const router = useHistory();
    const [stepData, setStepData] = useState({})

    router.listen((routeData) => {
        const pathName = routeData.pathname;
        const stepDetails = getCurrentStepLabelForTB(pathName)
        setStepData(stepDetails)
    })
    useEffect(() => {
        const pathName = router.location.pathname;
        const stepDetails = getCurrentStepLabelForTB(pathName)
        console.log({ stepDetails })
        setStepData(stepDetails)
    }, [router.location.pathname])
    return (
        <nav className="app_navbar">
            {
                sessionStorage.getItem("isTelebinding") === CAPS_Y && stepData.step ? (
                    <div className="app_navbar_logo_text">
                        <img onClick={() => {router.goBack()}} src={arrowLeftImg} alt="Back" />
                        <span className="step_number">Step {stepData.step} </span>
                        <span className="dot_between"> . </span>
                        <p className="step_title">{stepData.label}</p>
                    </div>
                ) : (
                    <div className="app_navbar_logo">
                        <img src={axisMaxLogo} alt="Logo" />
                    </div>
                )
            }
            {/* <div className="app_navbar_logo_text">
                <img src={arrowLeftImg} alt="Back" />
                <span className="step_number">Step 1 </span>
                <span className="dot_between"> . </span>
                <p className="step_title">Personal Details</p>
            </div> */}
            <div className="app_navbar_links">
                {isLoggedIn && <p onClick={handleLogout} className="app_navbar_link">Log out</p>}
            </div>
        </nav>
    );
};

export default AppNavbar;